module.exports = __webpack_public_path__ + "static/media/mainMenu.9a180581.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/docs/assets/mainMenu.PNG
// module id = 263
// module chunks = 0